import { render, staticRenderFns } from "./trainingModulePageMultipleChoice.vue?vue&type=template&id=d1e95bc2&scoped=true&"
import script from "./trainingModulePageMultipleChoice.vue?vue&type=script&lang=js&"
export * from "./trainingModulePageMultipleChoice.vue?vue&type=script&lang=js&"
import style0 from "./trainingModulePageMultipleChoice.vue?vue&type=style&index=0&id=d1e95bc2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1e95bc2",
  null
  
)

export default component.exports